module.exports = __webpack_public_path__ + "static/plates-3b657832f64f945d78c59ed42516d571.jpg";